import script from "./ApiAccessTokens.vue?vue&type=script&setup=true&lang=ts"
export * from "./ApiAccessTokens.vue?vue&type=script&setup=true&lang=ts"

import "../mypage.css?vue&type=style&index=0&id=bf2c9962&scoped=true&lang=css"
import "./ApiAccessTokens.vue?vue&type=style&index=1&id=bf2c9962&scoped=true&lang=css"

import exportComponent from "/src/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-bf2c9962"]])

export default __exports__